<template>
  <div id="settings">
    <header class="inner-head border-transparent h-14">
      <div class="flex justify-between">
        <h2 class="sub-head-title">Planning Display</h2>
      </div>
    </header>

    <div class="w-full h-10 ml-8">
      <p>
        Change how users view and teacher access to amend the Long Term Planning
        Grid.
      </p>
    </div>

    <div class="assessmentconfig w-11/12 ml-4 flex">
      <div class="bg-white w-full pb-3 mb-10">
        <div class="px-4">
          <form
            id="form-criteria"
            v-on:submit.prevent="saveSettings()"
            ref="formPlanning"
          >
            <!-- Section -->
            <section>
              <div class="flex flex-wrap mb-8">
                <div class="w-full">
                  <label class="form-label text-gray-500" for="grid-title">
                    Planning grid locked
                  </label>
                  <button
                    type="button"
                    class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-500 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-check"
                    v-bind:class="[
                      true === isPlanningLocked
                        ? 'bg-action-blue bg-opacity-75 text-white'
                        : 'bg-gray-200 text-gray-600',
                    ]"
                    @click="isPlanningLocked = true"
                  >
                    Locked
                  </button>

                  <button
                    type="button"
                    class="mr-3 mb-2 rounded p-2 px-6 cursor-pointer hover:bg-gray-500 hover:bg-opacity-50 hover:text-action-blue font-bold icon fa-times"
                    v-bind:class="[
                      false === isPlanningLocked
                        ? 'bg-action-blue bg-opacity-75 text-white'
                        : 'bg-gray-200 text-gray-600',
                    ]"
                    @click="isPlanningLocked = false"
                  >
                    Off
                  </button>
                </div>
              </div>
            </section>

            <!-- Section -->
            <section>
              <div class="flex flex-wrap mb-8">
                <div class="w-full">
                  <label class="form-label text-gray-500" for="grid-title">
                    Planning display grid
                    <span v-if="planningLevelSelected > 0">{{ planningLevelSelected }}</span> 
                  </label>
                  <div>
                    <div class="flex mt-2" v-if="1==3">
                      <div class="w-24">Columns:</div>
                      <div class="text-base">
                        <select
                          name="minutes"
                          v-model="col"
                          @change="onChange($event)"
                          class="px-3 bg-transparent border-b border-gray-500 border-solid"
                        >
                          <option
                            v-for="(cols, i) in options" 
                            :key="cols"
                            v-bind:value="i"
                          >
                            {{ i }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="flex my-3">
                      <div class="w-24">Rows:</div>
                      <div class="text-base">
                      <select
                        name="seconds"
                        v-model="row"
                        @change="onChange($event)"
                        class="px-3 bg-transparent border-b border-gray-500 border-solid"
                      >
                        <option
                          v-for="(rows, i) in options"
                          :key="rows"
                          v-bind:value="i"
                        >
                          {{ i }}
                        </option>
                      </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </form>

          <div
            class="w-full flex justify-end content-baseline space-x-10 text-right border-t"
          >
            <div class="w-9/12 flex justify-end">
              <p v-if="hasCompleted" class="text-green-500 mt-4">
                Settings configuration saved.
              </p>

              <p v-if="errored" class="text-red-500 mt-4">
                We are not able to retrieve this information at the moment,
                please try back later.
              </p>

              <div style="text-align: center" class="" v-if="loading">
                <i class="spinner fa fa-spinner fa-spin text-sm"></i>
                <p>Saving</p>
              </div>
            </div>

            <button
              @click="submitForm()"
              type="button"
              class="publish-button hover:opacity-75 mt-4"
            >
              Publish Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { settingsMixin } from "@/mixins/settingsMixin.js";

export default {
  name: "assessmentconfig",
  mixins: [settingsMixin],
  props: {},
  computed: {
    ...mapGetters({ 
      currentUser: "currentUser", 
      access: "currentAccess",
    settings: "settings", }),
  },
  watch: {},
  data() {
    return {
      divideValue: 9,
      options: [2,3,4,5,6,7,8,9],
      col: 2,
      row: 2,
    };
  },
  created() {},
  mounted() {
    this.row = this.settings.planningDisplayLevel === 0
              ? this.currentUser.isSecondaryBased ? 4 : 2
              : (this.settings.planningDisplayLevel + "").split(".")[1]

    this.col = this.currentUser.isSecondaryBased  ? 3 : 1
  },
  methods: {
    submitForm() {
      if (this.$refs.formPlanning.requestSubmit === undefined) {
        this.saveSettings();
      } else {
        this.$refs.formPlanning.requestSubmit();
      }
    },
    onChange() {
      this.planningLevelSelected = parseFloat(this.col + '.' + this.row)
    },
  },
  components: {},
};
</script>


<style scoped>

select {
  height: 1.9em;
  width: 3.0em

}

select:hover {
  cursor: pointer;
}
</style>

